<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";

  tbody tr:nth-child(odd) {
    background-color: #ededed;
  }
</style>
<template>
  <div>
    <div class="vx-row w-full">
        <vs-button :to="`/luminarias/${uuid}`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
    </div>
    <div class="vx-row w-full">
      <div class="w-full sm:w-auto  p-1">
        <vx-card class="p-6 h-full flex items-center justify-center">
          <div class="text-center">
            <iconLight width="120" height="120" iconColor="#ffbd59" :level="slideLight" />
          </div>
          <div class="text-center mt-2">
            <div class="inline-block align-middle font-bold" :class="{'text-grey': controlLight }" >Off</div>
            <div class="inline-block align-middle mx-2">
              <vs-switch v-model="controlLight" color="success" disabled="true"/>
            </div>
            <div class="inline-block align-middle font-bold" :class="{'text-grey': !controlLight }">On</div>
          </div>
          <div>
            <vs-slider v-model="slideLight" :min="0" :max="100" text-fixed="%" disabled="true"/>
          </div>
        </vx-card>
      </div>
      <div class="flex-grow flex-1 p-1">
        <vx-card class="p-4 pt-6 h-full w-full flex items-center justify-center">
            <div class="text-center">{{$t('Labels.LuminaryInformation')}}</div>
            <div >
              <div class="w-full p-2 py-4 sm:w-1/3 sm:inline-block">
                <div class="text-xs text-center mb-1">{{$t('Labels.Name')}}</div>
                <div class="font-bold text-center">{{response.name}}</div>
              </div>
              <div class="w-full p-2 py-4 sm:w-1/3 sm:inline-block">
                <div  class="text-xs text-center mb-1">{{$t('Labels.Voltage')}}</div>
                <div class="text-center" v-if="response.voltage_failure == '0'">
                  <div class="w-10 h-10 inline-block rounded-full align-middle bg-success" ></div>
                  <div class="inline-block align-middle ml-2 font-bold">OK</div>
                </div>
                <div class="text-center" v-else>
                  <div class="w-10 h-10 inline-block rounded-full align-middle bg-danger" ></div>
                  <div class="inline-block align-middle ml-2 font-bold">Error</div>
                </div>
              </div>
              <div class="w-full p-2 py-4 sm:w-1/3 sm:inline-block">
                <div  class="text-xs text-center mb-1">{{$t('Labels.Inclination')}}</div>
                <div class="text-center" v-if="parseInt(response.inclination) < 45">
                  <div class="w-10 h-10 inline-block rounded-full align-middle bg-success" ></div>
                  <div class="inline-block align-middle ml-2 font-bold">OK</div>
                </div>
                <div class="text-center" v-else>
                  <div class="w-10 h-10 inline-block rounded-full align-middle bg-danger" ></div>
                  <div class="inline-block align-middle ml-2 font-bold">Error</div>
                </div>
              </div>
              <div class="w-full p-2 py-4 sm:w-1/3 sm:inline-block">
                <div  class="text-xs text-center mb-1">{{$t('Labels.Circuit')}}</div>
                <div class="text-center" v-if="response.luminaires_circuit">
                  <div class="w-10 h-10 inline-block rounded-sm align-middle" :style="{ 'background-color': response.luminaires_circuit.color }"></div>
                  <div class="inline-block align-middle ml-2 font-bold">{{response.luminaires_circuit.name}}</div>
                </div>
                <div v-else class="text-center">N/A</div>
              </div>
              <div class="w-full p-2 py-4 sm:w-1/3 sm:inline-block">
                <div  class="text-xs text-center mb-1">{{$t('Labels.Current')}}</div>
                <div class="text-center" v-if="response.current_failure == '0'">
                  <div class="w-10 h-10 inline-block rounded-full align-middle bg-success" ></div>
                  <div class="inline-block align-middle ml-2 font-bold">OK</div>
                </div>
                <div class="text-center" v-else>
                  <div class="w-10 h-10 inline-block rounded-full align-middle bg-danger" ></div>
                  <div class="inline-block align-middle ml-2 font-bold">Error</div>
                </div>
              </div>
              <div class="w-full p-2 py-4 sm:w-1/3 sm:inline-block">
                <div  class="text-xs text-center mb-1">{{$t('Labels.Dimming')}}</div>
                <div class="text-center" v-if="response.dimming_failure == '0'">
                  <div class="w-10 h-10 inline-block rounded-full align-middle bg-success" ></div>
                  <div class="inline-block align-middle ml-2 font-bold">OK</div>
                </div>
                <div class="text-center" v-else>
                  <div class="w-10 h-10 inline-block rounded-full align-middle bg-danger" ></div>
                  <div class="inline-block align-middle ml-2 font-bold">Error</div>
                </div>
              </div>
            </div>
        </vx-card>
      </div>
      <div class="w-full sm:w-auto  p-1">
        <vx-card class="p-4 pt-6 h-full flex items-center justify-center">
          <div class="map-container m-2" v-if="status_mapa">
            <l-map :center="center" :zoom="zoom" v-if="response">
                <l-tile-layer :attribution="attribution" :url="url">
                </l-tile-layer>
                <l-marker :lat-lng="marker" ref="position_marker">
                    <l-icon :icon-anchor="staticAnchor">
                        <iconMarker width="25" height="25" iconColor="#4dc770" />
                    </l-icon>
                </l-marker>
            </l-map>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full my-2">
        <vs-button  @click="showFilters = !showFilters"  type="flat" color="grey" class="float-right">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle mr-2"><iconFilter/></iconBase>
          <span v-show="!showFilters"  class="font-bold">{{$t('Labels.ShowFilters')}}</span>
          <span v-show="showFilters"  class="font-bold">{{$t('Labels.HideFilters')}}</span>
        </vs-button>
      </div>
    </div>
    <div class="vx-row px-2 py-5" v-show="showFilters">
      <div class="vx-col w-full  sm:w-auto ">
        <vs-checkbox v-model="filterDates" class="inline-block"></vs-checkbox>
        <label class="font-bold">{{$t('Labels.From')}}</label>
        <datepicker :value="filters.begin_date" format="dd-MM-yyyy" :disabled="!filterDates" :disabled-dates="disabledDates" @selected="updateStartDate"></datepicker>
        <div v-if="!datesValid" class="text-xs text-danger">{{$t('Messages.DatesRange')}}</div>
      </div>
      <div class="vx-col w-full pt-1 sm:w-auto ">
        <label class="font-bold">{{$t('Labels.To')}}</label>
        <datepicker :value="filters.end_date" format="dd-MM-yyyy" :disabled="!filterDates" :disabled-dates="disabledDates" @selected="updateEndDate"></datepicker>
      </div>
      <div class="vx-col w-full text-center sm:w-auto">
        <vs-button @click="getHistory()" color="primary" class="mr-2 mt-6" :disabled="!datesValid"  >{{$t('Labels.Filter')}}</vs-button>
      </div>
    </div>
    <div class="vx-row mb-5">
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.OrderBy')}}</label><v-select @input="getHistory" class="align-middle inline-block" :options="columnOrders" v-model="filters.byColumn" :reduce="v => v.value"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <vs-button size="small" @click="filterOrders('ASC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder == 'ASC'}">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterAsc/></iconBase>
        </vs-button>
        <vs-button  size="small" @click="filterOrders('DESC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder != 'ASC'}">
          <iconBase iconName="filter_desc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterDesc/></iconBase>
        </vs-button> 
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.ByPage')}}</label><v-select @input="getHistory" class="align-middle inline-block" :options="byPage" v-model="filters.limit" :reduce="v => v.value"/> 
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <a v-if="urlDownload.length > 0" class="btn-primary float-right mt-4" :href="urlDownload" :download="response.name + '.csv'"><feather-icon icon="DownloadCloudIcon" /></a>
      </div>
    </div>
    <div class="vx-row">
      <div class="w-full">
        <vs-table  v-if="history" :data="history">
          <template slot-scope="{data}">
            <tbody>
              <vs-tr :data="item" :key="index" v-for="(item, index) in data">
                <listItem 
                  :value="item.createdAt" 
                  :description="$t('Labels.Date')"
                  :relativeTime="false"  />
                <td v-show="item.id_trama == '3'" >
                  <stateItem 
                    :status="item.state == '0'?'danger':'success'"
                    :description="item.state == '0'?$t('Labels.Off'):$t('Labels.On')"
                  />
                </td>
                <listItem v-show="item.id_trama == '1'" 
                  :value="item.electric_current" 
                  :description="$t('Labels.Current') + 'RMS'"
                  unit="A"  />
                <listItem v-show="item.id_trama == '1'" 
                  :value="item.electric_voltage" 
                  :description="$t('Labels.Voltage') + 'RMS'"
                  unit="V"  />
                <listItem v-show="item.id_trama == '1'" 
                  :value="item.active_power" 
                  :description="$t('Labels.ActivePower')"
                  unit="W"  />
                <listItem v-show="item.id_trama == '1'" 
                  :value="item.reactive_power" 
                  :description="$t('Labels.ReactivePower')"  
                  unit="VAR"/>
                <listItem v-show="item.id_trama == '1'" 
                  :value="item.apparent_power" 
                  :description="$t('Labels.ApparentPower')" 
                  unit="VA" />
                <td  v-show="item.id_trama == '1'" ></td>
                <listItem v-show="item.id_trama == '2'" 
                  :value="item.factor_power" 
                  :description="$t('Labels.PowerFactor')"  />
                <listItem v-show="item.id_trama == '2'" 
                  :value="item.active_energy" 
                  :description="$t('Labels.ActiveEnergy')" 
                  unit="Wh" />
                <listItem v-show="item.id_trama == '2'" 
                  :value="item.reactive_energy" 
                  :description="$t('Labels.ReactiveEnergy')" 
                  unit="VARh" />              
                <td v-show="item.id_trama == '2'"  colspan="3"></td>
                <listItem v-show="item.id_trama == '3'" 
                  :value="item.frequency" 
                  :description="$t('Labels.Frequency')" 
                  unit="Hz" />
                <listItem v-show="item.id_trama == '3'" 
                  :value="item.inclination" 
                  :description="$t('Labels.Inclination')" 
                  unit="°" />
                <listItem v-show="item.id_trama == '3'" 
                  :value="item.dimming" 
                  :description="$t('Labels.Dimming')"  />
                <td v-show="item.id_trama == '3'" >
                  <statusItem class="mb-1"
                    :status="item.voltage_failure == '0'?'success':'danger'"
                    :description="item.voltage_failure == '0'?$t('Labels.Voltage') :$t('Labels.FailureVoltage')"
                  />
                  <statusItem
                    :status="item.current_failure == '0'?'success':'danger'"
                    :description="item.current_failure == '0'? $t('Labels.Current') :$t('Labels.FailureCurrent')"
                  />
                </td>
                <td v-show="item.id_trama == '3'">
                  <statusItem  class="mb-1"
                    :status="item.state_failure == '0'?'success':'danger'"
                    :description="item.state_failure == '0'?$t('Labels.Relay'): $t('Labels.FailureRelay')"
                  />
                  <statusItem 
                    :status="item.dimming_failure == '0'?'success':'danger'"
                    :description="item.dimming_failure == '0'?$t('Labels.Dimming'): $t('Labels.FailureDimming')"
                  />
                </td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
        <vs-pagination class="mt-5" v-if="history" :max="10" :total="totalPages" v-model="currentx"></vs-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {request} from '@/request.js'
import statusItem from '@/components/statusItem/statusItem.vue'
import listItem from '@/components/listItem/listItem.vue'
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon
} from 'vue2-leaflet'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
import 'leaflet/dist/leaflet.css'
import {formatDate} from '@/helpers.js'
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import iconBase from '@/components/icons/iconBase'
import iconFilterAsc from '@/components/icons/iconFilterAsc'
import iconFilterDesc from '@/components/icons/iconFilterDesc'
import iconFilter from '@/components/icons/iconFilter'
import iconLight from '@/components/icons/iconLight'
import iconMarker from '@/components/icons/iconMarker'
import stateItem from '@/components/stateItem/stateItem'
/* global L:true */

export default {
  components: {
    statusItem,
    listItem,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    Datepicker,
    'v-select': vSelect,
    iconFilterDesc,
    iconFilterAsc,
    iconBase,
    iconFilter,
    iconLight,
    iconMarker,
    stateItem
  },
  data () {
    return {
      response: [],
      history:[],
      uuid: this.$route.params.uuid,
      typeControl: false,
      chartOptions: {
        width: 120,
        height: 120,
        redFrom: 82,
        redTo: 95,
        yellowFrom:5,
        yellowTo: 31,
        majorTicks: ['5', '10', '20', '40', '60', '80', '90', '95'],
        max: 100,
        min: 0
      },
      zoom:17,
      center: L.latLng(47.41322, -1.219482),
      url:'https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png',
      attribution:'',
      marker: L.latLng(47.41322, -1.219482),
      staticAnchor: [12, 27],
      icon_marker: [],
      status_mapa: false,
      editDevice: false,
      editClient: false,
      chartConsume: false,
      chartWeek: false,
      chartRecharge: false,
      clientEditor: {},
      deviceEditor: {},
      filters:{
        limit: 20,
        offset: 0,
        byColumn: 'createdAt',
        byOrder: 'ASC',
        begin_date: new Date(),
        end_date: new Date()
      },
      currentx: 1,
      totalPages: 0,
      columnOrders:[
        {label: this.$t('Labels.Date'), value: 'createdAt'},
        {label: this.$t('Labels.Status'), value: 'state'}
      ],
      filterDates: false,
      byPage:[
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 75, value: 75},
        {label: 100, value: 100}
      ],
      showFilters: false,
      controlLight: false,
      slideLight:0,
      disabledDates: {
        from: new Date()
      },
      urlDownload:''
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: `luminaires_devices/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.slideLight = parseInt(this.response.dimming) * 100 / 255
        this.slideLight > 0 ? this.controlLight = true : this.controlLight = false 
        if (this.response.latlong.length > 0) {
          const location = this.response.latlong.split(',')
          this.marker = L.latLng(location[0], location[1])
          this.center = L.latLng(location[0], location[1])
          this.status_mapa = true
        }
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    async getHistory () {
      const filter = {}
      filter.limit = this.filters.limit
      filter.offset = this.filters.offset
      filter.byColumn = this.filters.byColumn
      filter.byOrder = this.filters.byOrder

      if (this.filterDates) {
        filter.begin_date = formatDate(this.filters.begin_date)
        filter.end_date = formatDate(this.filters.end_date)
      }

      const params = {
        url: `luminaires_devices/${this.uuid}/historic`,
        method: 'GET',
        params: filter
      }
      await request(params).then(response => {
        this.history = response.data.data.rows
        this.setPages(response.data.data.count)
        this.createCsv()
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    getImgUrl (name) {
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${  name  }.svg`)
    },
    relativeTimeConvert (date) {
      return this.$dayjs().to(this.$dayjs(date))
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    },
    filterOrders (param) {
      this.filters.byOrder = param
      this.getHistory()
    },
    updateStartDate (date) {
      this.filters.begin_date = date
    },
    updateEndDate (date) {
      this.filters.end_date = date
    },
    createCsv () {
      const csv = []
      const headers = []
      headers.push(this.$t('Labels.Date'))
      headers.push(this.$t('Labels.Status'))
      headers.push(`${this.$t('Labels.Current') } RMS`)
      headers.push(`${this.$t('Labels.Voltage')  } RMS`)
      headers.push(this.$t('Labels.ActivePower'))
      headers.push(this.$t('Labels.ReactivePower'))
      headers.push(this.$t('Labels.ApparentPower'))
      headers.push(this.$t('Labels.PowerFactor'))
      headers.push(this.$t('Labels.ActiveEnergy'))
      headers.push(this.$t('Labels.ReactiveEnergy'))
      headers.push(this.$t('Labels.Frequency'))
      headers.push(this.$t('Labels.Inclination'))
      headers.push(this.$t('Labels.Dimming'))
      headers.push(this.$t('Labels.FailureVoltage'))
      headers.push(this.$t('Labels.FailureCurrent'))
      headers.push(this.$t('Labels.FailureRelay'))
      headers.push(this.$t('Labels.FailureDimming'))
      csv.push(headers.join(','))
      this.history.map(item => {
        const row = []
        row.push(item.createdAt)
        row.push((item.state === '0' ? this.$t('Labels.Off') : this.$t('Labels.On')))
        row.push(`${item.electric_current}A`)
        row.push(`${item.electric_voltage}V`)
        row.push(`${item.active_power}W`)
        row.push(`${item.reactive_power}VAR`)
        row.push(`${item.apparent_power}VA`)
        row.push(item.factor_power)
        row.push(`${item.active_energy}Wh`)
        row.push(`${item.reactive_energy}VARh`)
        row.push(`${item.frequency}Hz`)
        row.push(`${item.inclination}°`)
        row.push(item.dimming)
        row.push((item.voltage_failure === '0' ? 'OK' : 'Error'))
        row.push((item.current_failure === '0' ? 'OK' : 'Error'))
        row.push((item.state_failure === '0' ? 'OK' : 'Error'))
        row.push((item.dimming_failure === '0' ? 'OK' : 'Error'))
        csv.push(row.join(','))
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], {type: 'text/csv'})
      this.urlDownload = window.URL.createObjectURL(csvFile)
    }
  },
  computed: {
    datesValid () {
      const begin = new Date(this.filters.begin_date)
      const end = new Date(this.filters.end_date)
      console.log(begin, end, this.filterDates)

      return ((begin <= end && this.filterDates) || this.filterDates === false)  
    }
  },
  created () {
    screen.width < '576' ? this.showFilters = false : this.showFilters = true
    this.getResponse()
    this.getHistory()
  },
  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getHistory()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    }
  }
}
</script>